import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import moment from 'moment';

import ActionsForm from '../../../ActionsForm/ActionsForm.jsx';

const ACTIONS = {
    'your': [
        {id: 'cancel', name: 'Mark as reviewed'},
        {id: 'unassign', name: 'Unassign'}
    ],
    'none': [
        {id: 'assign', name: 'Assign to me'}
    ],
    'other': [
        {id: 'unassign', name: 'Unassign'}
    ]
};

class DepositRestriction extends React.Component {
    static propTypes = {
        type: PropTypes.string,
        status: PropTypes.string,
        className: PropTypes.string,
        onCancelRequest: PropTypes.func.isRequired,
        onAssignRequest: PropTypes.func.isRequired,
        onUnassignRequest: PropTypes.func.isRequired,
        onOpenAccountRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        className: ''
    };

    constructor(props, context) {
        super(props, context);
    }

    openAccount(id, name) {
        this.props.onOpenAccountRequest(id, name);
    }

    doAction(restriction) {
        return (field, action) => {
            const { onCancelRequest, onAssignRequest,
                    onUnassignRequest } = this.props;
            if (action === 'unassign') {
                onUnassignRequest(restriction);
            } else if (action === 'assign') {
                onAssignRequest(restriction);
            } else if (action === 'cancel') {
                onCancelRequest(restriction);
            }
        };
    }

    renderRow(restriction, type) {
        let row = (
            <tr key={restriction.get('id')} data-test={`deposit-restriction-row-${restriction.get('accountId', Map())}`}>
                <td>
                    <div className={'contents'}>
                        <div className={'customerTab'} data-test='customer-tab'
                             onClick={(e) => this.openAccount(restriction.get('accountId', Map()),
                                 restriction.get('accountName', Map()))}>
                                <span className={'status online'}></span>
                            {restriction.get('accountName', Map())}
                            <br/>
                            <span className={'customerId'}>{restriction.get('accountId', Map())}</span>
                            <span className={'tag'}></span>
                        </div>
                    </div>
                </td>
                <td data-test='date-created'>{moment(restriction.get('createdAt')).format('DD-MM-YYYY HH:mm')}</td>
                <td data-test='expiry-date'>
                    {restriction.getIn( ['details', 'permanent'] ) === true
                        ? 'Permanent'
                        : moment(restriction.getIn([ 'details', 'expiryDate'])).format('DD-MM-YYYY HH:mm')}
                </td>
                <td data-test='description'>
                    <div>{restriction.getIn([ 'details', 'description'])}</div>
                </td>
                <td>
                    <ActionsForm
                        onChange={this.doAction.call(this, restriction)}
                        actions={ACTIONS[type]}
                        dataTest='deposit-restriction-action-form'
                    />
                </td>
            </tr>
        );
        return [ row ];
    }

    render() {
        const {data, type} = this.props;
        let table = (
            <table className={ 'deposit-restrictions' }>
                <thead>
                <tr>
                    <th data-test='customer-header'>Customer</th>
                    <th data-test='date-created-header'>Date Created</th>
                    <th data-test='expiry-date-header'>Expiry Date</th>
                    <th data-test='description-header'>Description</th>
                    <th data-test='action-header'>Action</th>
                </tr>
                </thead>
                <tbody>
                {data.map(d => this.renderRow(d, type)).toArray()}
                </tbody>
            </table>
        );

        return (
            <div>{table}</div>
        );
    }
}

export default DepositRestriction;
